export default __webpack_public_path__ + "static/media/cny_2024.05e4de7b.webp";